.nest-shell-header {
  @apply bg-white text-foreground px-10 py-8 flex items-center justify-between gap-2 font-medium text-xl;
}
